import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    {/* <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">

        <path
          d="M32.4,62c-5.9,0.5-1.8-23.1-2.9-25.7c-2.7,1.2-5.4-2.3-2.4-4C56.9,18,65.4,63.8,32.4,62z M37.6,34.4h-1.5l-1.6,0.2v22.8
        l3.1-0.6c1-0.1,2-0.4,3-0.6c1-0.2,1.9-0.6,2.8-1c0.8-0.4,1.6-1,2.1-1.7c1.1-1.2,1.9-2.5,2.5-4c0.5-1.5,0.8-3,0.8-4.6
        c0-1.4-0.2-2.7-0.7-4c-0.4-1.2-1.1-2.4-2-3.3c-1-1-2.2-1.8-3.5-2.3C41,34.6,39.3,34.3,37.6,34.4z"
          fill="currentColor"
        />

        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g> */}
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">

        <path fill="currentColor" d="M32.3,62.2c-5.9,0.5-1.8-23.3-3-26c-0.6-2-1.3-2.3-2.4-4.1C57.1,17.7,65.7,64,32.3,62.2z M37.6,34.3h-1.5
			l-0.9,0.1c-0.4,0-0.7,0.4-0.7,0.7v21.4c0,0.5,0.4,0.8,0.9,0.8l2.2-0.4c1-0.1,2-0.4,3.1-0.6c1-0.2,1.9-0.6,2.8-1
			c0.8-0.4,1.6-1,2.2-1.7c1.1-1.2,1.9-2.5,2.5-4c0.5-1.5,0.8-3.1,0.8-4.7c0-1.4-0.2-2.7-0.7-4c-0.4-1.3-1.1-2.4-2-3.4
			c-1-1-2.2-1.8-3.6-2.3C41,34.5,39.3,34.2,37.6,34.3z"/>
        <polygon id="Shape" points="39,-0.4 -0.4,21.8 -0.4,67.2 39,90.4 78.4,68.2 78.4,22.8 		" />
      </g>
    </g>
  </svg>
);

export default IconLogo;
